import { Const } from '../lib/const.cls'

export const mutations = {
	//-------------------------------SUBSCRIPTION LIST------------------------------------------

	[Const.SET_SUBSCRIPTION_LIST] (state, {payload = {total: 0, records: []}}) {
		try {
			state.subscriptionData = payload
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},

	[Const.SET_SUBSCRIPTION_DETAIL] (state, {payload = {}}) {
		try {
			state.subscriptionDetail = payload
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	//---------------------------------------------------listing-----------------------------------------------------------------
	
	[Const.SET_LEAD_USER_LISTING] (state, data) {									
		try {
			state.leadUserListing = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_KYC_USER_LISTING] (state, data) {									
		try {
			state.kycUserListing = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},

	[Const.SET_CVL_RESPONSE] (state, data) {									
		try {
			state.cvlResponse = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},

	[Const.SET_CVL_STATUS] (state, data) {									
		try {
			state.cvlStatus = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},

	[Const.SET_USER_PAN_ATTEMPT_LIST] (state, data) {									
		try {
			state.userPanAttemptList = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_USER_LIST_FOR_SQUADIQ] (state, data) {									
		try {
			state.userListForSquadiq = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},

	[Const.SET_ADMIN_CHART_DATA] (state, data) {									
		try {
			state.Chartdata = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},

	[Const.SET_ADMIN_DEPOSIT_DATA] (state, data) {									
		try {
			state.Depositchart = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},

	[Const.SET_ADMIN_WITHDRAWAL_DATA] (state, data) {									
		try {
			state.Withdrawalchart = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},

	[Const.SET_ADMIN_REGISTRATION_LINE_DATA] (state, data) {									
		try {
			state.Chartlinedata = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},

	[Const.SET_API_KEY_LIST] (state, data) {									
		try {
			state.apiKeyData = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},

	[Const.SET_PAN_DATA] (state, data) {									
		try {
			state.panData = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},

	[Const.SET_RISING_RECONCILATION_LIST] (state, data) {									
		try {
			state.rising_reconcilation_list = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_DEBIT_LIST] (state, data) {									
		try {
			state.debit_list = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_LOCK_UNLOCK_DATA] (state, data) {									
		try {
			state.get_lock_unlock_data = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_ADMIN_USER_LISTING] (state, data) {									
		try {
			state.admin_user_list = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_SUPPORT_LIST] (state, data) {									
		try {
			state.support_list = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_DEMAT_PENDING_LIST] (state, data) {									
		try {
			state.demat_pending_list = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	
	[Const.SET_CATEGORISATION_USER_LIST] (state, data) {									
		try {
			state.categorisation_list = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_CATEGORISATION_USER_DETAIL] (state, data) {									
		try {
			state.categorisation_detail = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_STAGGING_RISING_LIST] (state, data) {									
		try {
			state.stagging_rising_list = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_STAGGING_RISING_LIST_CSV] (state, data) {									
		try {
			state.stagging_rising_list_csv = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	//----------------------------------------------------view--------------------------------------------------------------------
	[Const.SET_SUPPORT_VIEW] (state, data) {									
		try {
			state.support_view = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_SUPPORT_DOCS] (state, data) {									
		try {
			state.support_view_doc = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_VIEW_ADMIN_USER_DETAIL] (state, data) {									
		try {
			state.admin_view_user_detail = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_DASHBOARD_DATA] (state, data) {									
		try {
			state.dashboard_data = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_NEW_REGISTERATIONS] (state, data) {									
		try {
			state.new_reg = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	
	//--------------------------------------------------dropdown------------------------------------------------------------------
	[Const.SET_SUPPORT_REASON_LIST] (state, data) {
		try {
			state.support_reason_list = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},



	//------------------------------------knowledge------------------------------------------------------

	[Const.SET_CAT_LIST] (state, data) {
		try {
			state.catList = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},

	[Const.SET_ARTICLE_LIST] (state, data) {
		try {
			state.articleList = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_CVL_STATUS_LIST] (state, data) {
		try {
			state.cvlStatusList = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_CVL_RESPONSE_LIST] (state, data) {
		try {
			state.cvlResponseList = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},

	//-------------------------------nominee data------------------------------------------

	[Const.SET_USERS_LIST_FOR_NOMINEE] (state, data) {
		try {
			state.UserslistForNominee = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},

	[Const.SET_NOMINEE_DETAIL] (state, data) {
		try {
			state.NomineeDetail = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	//-------------------------------ADMIN REFERRED LIST------------------------------------------

	[Const.SET_ADMIN_REFERRED_LIST] (state, data) {
		try {
			state.adminReferredList = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},
	[Const.SET_TAX_REPORT_LIST1] (state, data) {									
		try {
			state.tax_report = data
		} catch (ex) {
		  console.debug('set state EX', ex)
		}
	},


}



// WEBPACK FOOTER //
// ./src/plugins/prism_admin/provider/candle-history/store-addons/mutations.js